import { PublishedResults } from '../../../components/results/shared/PublishedResults';

export default function StudentViewTest() {
  return <PublishedResults assessmentType="first_test" audience="student" />;
}
